export default __webpack_public_path__ + "img/img_taqy-fb834fe10c6fd1fe6979c508c3b5c793.png";